import L from 'leaflet';
import PropTypes from 'prop-types';
import { useEffect } from 'react';

import useLeafletLayer from './useLeafletLayer';

// Style props given at top level apply at creation; later restyling goes through pathOptions
function LeafletPolygon(props) {
  const {
    positions,
    pathOptions,
    eventHandlers,
    ...styleOptions
  } = props;

  const polygon = useLeafletLayer(
    () => L.polygon(positions, { ...styleOptions, ...pathOptions }),
    eventHandlers,
  );

  useEffect(
    () => {
      if (polygon) polygon.setLatLngs(positions);
    },
    [polygon, positions],
  );

  useEffect(
    () => {
      if (polygon && pathOptions) polygon.setStyle(pathOptions);
    },
    [polygon, pathOptions],
  );

  return null;
}

LeafletPolygon.propTypes = {
  positions: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
    PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number,
    }),
  ])).isRequired,
  pathOptions: PropTypes.shape({}),
  eventHandlers: PropTypes.shape({}),
};

export default LeafletPolygon;
